// Release 4: presentation only. No changes to prices, forms or selling plans.
(function () {
  'use strict';
  function choose(variant, planId) {
    if (!variant) return null;
    if (!planId) return variant;
    return (variant.plans || []).find(function (p) { return String(p.id) === String(planId); }) || null;
  }
  if (typeof module !== 'undefined' && module.exports) { module.exports = {choose: choose}; return; }
  var el = document.getElementById('neotes-unit-price-data');
  if (!el) return;
  var data;
  try { data = JSON.parse(el.textContent); } catch (_) { return; }
  function setText(node, text) { if (node.textContent !== text) node.textContent = text; }
  function update(form) {
    var field = form.querySelector('input[name="id"]');
    if (!field) return;
    var variant = data.variants.find(function (v) { return String(v.id) === field.value; });
    if (!variant || variant.unit == null) return;
    var hidden = form.querySelector('input.neo-selling-plan-hidden');
    var plan = hidden || form.querySelector('input[name="selling_plan"]:checked, select[name="selling_plan"], input[type="hidden"][name="selling_plan"]');
    var id = plan ? plan.value : '';
    // Native subscriptions app may expose only data-radio-type inputs.
    if (!hidden && !id) {
      var block = form.querySelector('.shopify_subscriptions_app_block[data-variant-id="'+variant.id+'"]:not(.shopify_subscriptions_app_block--hidden)');
      var radio = block && block.querySelector('input[data-radio-type="selling_plan"]:checked');
      if (radio) id = radio.dataset.sellingPlanId || radio.value;
    }
    var selected = choose(variant, id);
    if (!selected || selected.unit == null) return;
    form.querySelectorAll('[data-js-unit-price="money"]').forEach(function (node) { setText(node, selected.formatted); });
    var reference = (Number(variant.reference) === 1 ? '' : String(variant.reference) + ' ') + variant.referenceUnit;
    form.querySelectorAll('.neo-subscription-note__unitprice').forEach(function (node) { setText(node, selected.formatted + ' / ' + reference); });
  }
  function boot() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      var pending = false;
      function schedule() {
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () { pending = false; update(form); });
      }
      form.addEventListener('change', schedule);
      form.addEventListener('click', schedule);
      document.addEventListener('variant:change', schedule);
      // Observe display replacement only; no form-value or purchase mutations.
      new MutationObserver(schedule).observe(form, {childList:true,subtree:true});
      schedule();
      [150,400,900,1700].forEach(function (ms) { setTimeout(schedule,ms); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
